import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import LoginPage from './Pages/LoginPage';
import Dashboard from './Pages/Dashboard';
import Navbar from "./Pages/NavBar";
import Register from "./Pages/Register";
import CreateCompetition from "./Pages/CreateCompetition";
import {AuthProvider} from "./Pages/AuthContext";
import Competitions from "./Pages/Competitons";
import CompetitionDetails from "./Pages/CompetitionDetails";
import CreateWorkout from "./Pages/CreateWorkout";
import Leaderboard from "./Pages/LeaderBoard/Leaderboard";
import Profile from "./Pages/Profile/Profile";
import SubmitResult from "./Pages/SubmitResult";
import RegisterCompetition from "./Pages/CompetitionRegister";
import AdminPortal from "./Pages/AdminPortal";
import ForgotPassword from "./Pages/ForgotPassword";
import ResetPassword from "./ResetPassword";
import CreateOrJoinTeam from "./Pages/CreateOrJoinTeam";

function App() {

  return (
      <AuthProvider>
          <Router>
              <Navbar />
            <Routes>
                <Route path="/" element={<Leaderboard />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/register" element={<Register />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/competitions/create" element={<CreateCompetition />} />
                <Route path="/competitions" element={<Competitions />} />
                <Route path="/competition/:competition_id" element={<CompetitionDetails />} />
                <Route path="/workouts/create" element={<CreateWorkout />} />
                <Route path="/leaderboard" element={<Leaderboard />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/submit-result" element={<SubmitResult />} />
                <Route path="/register-competition" element={<RegisterCompetition />} />
                <Route path="/admin" element={<AdminPortal />} />
                <Route path="/teams/join" element={<CreateOrJoinTeam />} />
            </Routes>
          </Router>
      </AuthProvider>
  );
}

export default App;
